import axios from "axios";
import { toastr } from "react-redux-toastr";

import URL from "../config/api";

export const readUnreadMessage = id => {
  let message = {};
  message.id = id;
  return (dispatch, getState) => {
    axios.post(`${URL.api}message/update`, { ...message }).then(resp => {
      if (!resp.data.success) {
        toastr.error("Fail", resp.data.error);
      }
    });
  };
};

export const toggleMenu = () => (dispatch, getState) => {
  dispatch({ type: "TOGGLE_MENU" });
};

export const toggleMinimizeMenu = () => (dispatch, getState) => {
  dispatch({ type: "TOGGLE_MINIMIZE_MENU" });
};

export const setMenu = menu => (dispatch, getState) => {
  dispatch({ type: "SET_MENU", payload: menu });
};

export const setMinimizeMenu = minimize => (dispatch, getState) => {
  dispatch({ type: "SET_MINIMIZE_MENU", payload: minimize });
};
